import React, { Component } from 'react';
import './Category.css';
import { withSize } from 'react-sizeme';
import { Image } from 'pixboost-react';
import pixboostConfig from '../../config/pixboost';
import Products from '../Products/Products';
import PageTitle from '../content-blocks/PageTitle/PageTitle';
import ContentSlider from '../ContentSlider/ContentSlider';
import Tile from '../content-blocks/Tile/Tile';
import { Link } from 'react-router-dom';
import scrollToElement from 'scroll-to-element';
import Recommendations from '../content-blocks/Recommendations/Recommendations';
import LookBook from '../content-blocks/LookBook/LookBook';
import { breakPoints } from '../../config/breakpoints';
import lodashGet from 'lodash.get';

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
const getSkus = ({ category, subcategory }) => {
  if (!subcategory) {
    return '';
  }

  let skus;
  if (subcategory.viewAll) {
    skus = category.subcategories
      .reduce((acc, item) => {
        if (!item.skus) {
          return acc;
        }
        item.skus
          .replace(/\s/g, '')
          .split(',')
          .forEach(sku => {
            if (acc.indexOf(sku) < 0) {
              acc.push(sku);
            }
          });
        return acc;
      }, [])
      .join(',');
  } else {
    skus = (subcategory.skus || '').replace(/\s/g, '');
  }
  return skus;
};
const ProductsSubcategory = ({ category, subcategory }) => {
  const skus = subcategory ? getSkus({ category, subcategory }) : '';

  return (
    <div className={'js-active-subcat'} id={'store-app-products-wrapper'}>
      {skus && <Products skus={skus} />}
    </div>
  );
};

class Category extends Component {
  componentDidMount() {
    if (!this.props.activeSubcategoryId) {
      if (document && document.documentElement) {
        // Scroll to page title and allow for Officeworks header offset
        document.documentElement.scrollTop = 150;
      }
    }
    this.scrollToSearch();
  }

  componentDidUpdate() {
    if (!this.props.location) {
      return;
    }
    this.scrollToSearch();
  }

  scrollToSearch() {
    setTimeout(() => {
      const scrollTo = getParameterByName(
        'scrollto',
        this.props.location.search
      );
      if (scrollTo) {
        Category.scrollTo(scrollTo);
      }
    }, 700);
  }

  static scrollTo(id) {
    scrollToElement(`#${id}`, {
      offset: -75,
      duration: 750
    });
  }

  scrolltoFeatures() {
    Category.scrollTo('featuresImage');
  }

  render() {
    if (!this.props.storeConfig || !this.props.category) {
      return null;
    }

    const {
      category,
      size: { width }
    } = this.props;

    const activeSubcategory = category.subcategories.reduce(
      (selected, subcat, index) => {
        if (!selected) {
          return {
            ...subcat,
            index
          };
        }
        if (subcat.id === this.props.activeSubcategoryId) {
          return {
            ...subcat,
            index
          };
        }
        return selected;
      },
      null
    );

    const { imageBasePath, name, backlink } = this.props.storeConfig;
    const backlinkEnabled = lodashGet(backlink, 'enabled');
    const backlinkUrl =
      lodashGet(backlink, 'url.length') > 0 ? backlink.url : '/#';

    const backlinkText =
      lodashGet(backlink, 'text.length') > 0
        ? backlink.text
        : `Back to ${name}`;

    return (
      <div className="category-page">
        <div className="header">
          {backlinkEnabled && (
            <div className="back-link">
              <Link to={backlinkUrl}>
                <span>&lt; {backlinkText}</span>
              </Link>
            </div>
          )}
          <PageTitle
            contentBlock={{
              title: category.name,
              description: category.description
            }}
            storeConfig={this.props.storeConfig}
          />
        </div>

        {category.lookbook && category.lookbook.enabled && (
          <LookBook {...category.lookbook} imageBasePath={imageBasePath} />
        )}

        {activeSubcategory && (
          <div>
            <div
              className={`section four-wide swipeable ${
                category.lookbook && category.lookbook.enabled
                  ? 'has-lookbook'
                  : ''
              }`}
              id={'subcategories'}
            >
              {category.lookbook && category.lookbook.enabled && (
                <h2>Shop the {category.name} range</h2>
              )}
              {width <= breakPoints.md - 1 ? (
                <div className="category-links">
                  {this.props.category.subcategories.map(c => {
                    return (
                      <Link
                        to={`/${category.id}/${c.id}?scrollto=subcategories`}
                        key={`subcat-${c.id}`}
                        className={
                          activeSubcategory.id === c.id ? 'active' : ''
                        }
                      >
                        {c.name}
                      </Link>
                    );
                  })}
                </div>
              ) : (
                <ContentSlider
                  size={'four-wide'}
                  activeIndex={activeSubcategory.index}
                >
                  {this.props.category.subcategories.map(c => {
                    return (
                      <Link
                        to={`/${category.id}/${c.id}?scrollto=subcategories`}
                        key={`subcat-${c.id}`}
                        className="tile-link"
                      >
                        <Tile
                          storeConfig={this.props.storeConfig}
                          contentBlock={{
                            title: c.name,
                            image: c.image,
                            viewAll: c.viewAll
                          }}
                          className={
                            activeSubcategory.id === c.id ? 'active' : ''
                          }
                          lazy={false}
                        />
                      </Link>
                    );
                  })}
                </ContentSlider>
              )}
            </div>
            {activeSubcategory.name && (
              <div className="text-left my-double" id="subcategory-description">
                <h2>{activeSubcategory.name}</h2>
                {activeSubcategory.description && (
                  <p className="text-left">{activeSubcategory.description}</p>
                )}
                {activeSubcategory.featureImage &&
                  activeSubcategory.description && (
                    <a
                      className="btn btn-primary btn-scroll-to"
                      onClick={() => this.scrolltoFeatures()}
                    >
                      View features
                    </a>
                  )}
              </div>
            )}
            <ProductsSubcategory
              category={category}
              subcategory={activeSubcategory}
            />
            {activeSubcategory.recommendations && (
              <Recommendations
                contentBlock={{
                  recommendationsType: 'category',
                  recommendationsValue: activeSubcategory.recommendations
                }}
              />
            )}
            {activeSubcategory.featureImage && activeSubcategory.description && (
              <div className="mt-double features-image" id="featuresImage">
                <h3>{activeSubcategory.name} features</h3>
                <Image
                  alt={activeSubcategory.name}
                  config={pixboostConfig}
                  src={`${imageBasePath}${activeSubcategory.featureImage ||
                    activeSubcategory.featureImage1}`}
                  op={'asis'}
                />
                {activeSubcategory.featureImage2 && (
                  <Image
                    alt={activeSubcategory.name}
                    config={pixboostConfig}
                    src={`${imageBasePath}${activeSubcategory.featureImage2}`}
                    op={'asis'}
                  />
                )}
                {activeSubcategory.featureImage3 && (
                  <Image
                    alt={activeSubcategory.name}
                    config={pixboostConfig}
                    src={`${imageBasePath}${activeSubcategory.featureImage3}`}
                    op={'asis'}
                  />
                )}
                {category.recommendations && (
                  <Recommendations
                    contentBlock={{
                      recommendationsType: 'category',
                      recommendationsValue: category.recommendations
                    }}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withSize()(Category);



// WEBPACK FOOTER //
// ./src/components/Category/Category.js